// @ts-nocheck

import { mapValues as _mapValues } from 'lodash';

import recomputeBasketStateForOperations from '../utils/recomputeBasketStateForOperations';

const acceptChange = (state) => {
  const { items } = state;
  const nextItems = _mapValues(items, (item) => ({
    ...item,
    previousValue: undefined,
    changed: undefined,
  }));
  return {
    ...state,
    items: nextItems,
  };
};

/**
 * Return the nextState corresponding to the BASKET_ACCEPT_CHANGES action
 *
 * @param  {Object} state The actual state.
 * @return {Object}       Return the new state.
 */
const basketAcceptChanges = (state, _, globalState) => {
  const nextState = acceptChange(state);
  return recomputeBasketStateForOperations(nextState, globalState);
};

export default basketAcceptChanges;
